import request from '@/utils/request'

const uploadApi = {
  presignedUrl: '/login/oss/presignedUrl',
  zip: '/resources/zip',
  resource: '/resources/file'
}

export function presignedUrl(fileName, fileType) {
  return request({
    url: uploadApi.presignedUrl,
    method: 'get',
    params: { fileName, fileType }
  })
}

export function zip({ formData, onUploadProgress }) {
  return request({
    url: uploadApi.zip,
    method: 'post',
    // timeout: 120000,
    onUploadProgress,
    data: formData
  })
}

export function resource({ formData, onUploadProgress }) {
  return request({
    url: uploadApi.resource,
    method: 'post',
    // timeout: 120000,
    onUploadProgress,
    data: formData
  })
}
